import Vue from "vue";

import App from "./App.vue";
import router from "./router";
import { i18n } from "./i18n.js";
import vSelect from "vue-select";

import * as Sentry from "@sentry/vue";

Sentry.init({
  Vue,
  dsn: "https://a5ad5baf36254ee3addcab20787f131f@gt.mst.su/4",
  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracePropagationTargets: ["localhost", "api.firerisks.ru", "api-stage.firerisks.ru", /^\//],
    }),
  ],
  tracesSampleRate: 0.2,
  environment: process.env.NODE_ENV,
});

import BootstrapVue from "bootstrap-vue";
Vue.use(BootstrapVue);
import Meta from "vue-meta";
Vue.use(Meta);

Vue.config.productionTip = false;
import Multiselect from "vue-multiselect";
Vue.component("multiselect", Multiselect);
import axios from "axios";

vSelect.props.components.default = () => ({
  OpenIndicator: {
    render: (createElement) => createElement("span", { class: "select-arrow" }),
  },
});
Vue.component("v-select", vSelect);

import VueAxios from "vue-axios";
import VueAuth from "@websanova/vue-auth";
Vue.use(VueAxios, axios);
import Snotify from "vue-snotify/vue-snotify.min.js";
Vue.use(Snotify);
Vue.axios.defaults.baseURL = `${process.env.VUE_APP_API_URL}/v2/`;
Vue.axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status == 403) {
      localStorage.removeItem("token");
      Vue.auth.logout({
        makeRequest: true,
        redirect: { name: "Index" },
        success() {
          console.log("success " + this.context);
        },
        error() {
          console.log("error " + this.context);
        },
      });
    }
    if (error.response.status == 409) {
      Vue.prototype.$snotify.error(error.response.data, {
        timeout: 1000,
        showProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        position: "rightTop",
      });
      return false;
    }
    if (error.response.status == 401) {
      if (router.currentRoute.fullPath !== "/login") {
        router.push({ path: "/login" });
      }
    }
    if (error.response.status == 302) {
      alert("Похоже что сервер сейчас недоступен. Попробуйте зайти позднее.");
    }
    return Promise.reject(error);
  }
);
Vue.router = router;

Vue.use(VueAuth, {
  auth: require("@websanova/vue-auth/drivers/auth/bearer.js"),
  http: require("@websanova/vue-auth/drivers/http/axios.1.x.js"),
  router: require("@websanova/vue-auth/drivers/router/vue-router.2.x.js"),
  authRedirect: { path: "/login" },
  tokenStore: ["localStorage", "cookie"],
});

Vue.axios.defaults.headers.common["lang"] = i18n.locale;

Vue.use(require("vue-chat-scroll"));
import moment from "moment-timezone";
import "moment/locale/ru";
Vue.use(require("vue-moment"), {
  moment,
});
import VueKonva from "vue-konva";
import * as VueGoogleMaps from "vue2-google-maps";
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAm5QsJ9eiXC3KQ5VW3XXKyzc-ptJbtZh0",
    libraries: "places",
  },
  installComponents: true,
});
import { LMap, LTileLayer } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";

Vue.component("l-map", LMap);
Vue.component("l-tile-layer", LTileLayer);
import VueTour from "vue-tour";

require("vue-tour/dist/vue-tour.css");

Vue.use(VueTour);
Vue.use(VueKonva);

import VueFormGenerator from "vue-form-generator";
import "vue-form-generator/dist/vfg.css";

Vue.use(VueFormGenerator);
import ModuleLibrary from "vfg-field-array";

// Install this library
Vue.use(ModuleLibrary);
import VfgFieldObject from "vfg-field-object";
Vue.use(VfgFieldObject);

import { ServerTable } from "vue-tables-2";
Vue.use(ServerTable);

new Vue({
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
